import { createApp } from 'vue'
import App from './App.vue'
import defaults from './config.js'
import Vue3Storage from "vue3-storage";
const  appID = "wishlist-main-app"
const  rootelement =  document.getElementById(appID);
const attributenames = rootelement.getAttributeNames();
let attributes = {}
attributenames.forEach(function(el) {
    if(el.indexOf('data-cfg-') === 0) {
        attributes[el.substr(9)] = isNaN(parseInt(rootelement.getAttribute(el))) ? rootelement.getAttribute(el) : parseInt(rootelement.getAttribute(el))
    }
})
const options = { ...defaults, ...attributes}
createApp(App, { cfg: options}).use(Vue3Storage).mount('#' + appID)


